import SecondaryButton from "./common/secondary-btn";
function RelatedService({toggleModal, id})
{
const title="Related Services"; 

const glocifyservices=[
    {
        icon:'https://glocify.com/images/rel1.svg',
        title:'eCommerce App/Websites',
        desc:'We streamline payments for your eCommerce platforms with Stripe integration.'
    },
    {
        icon:'https://glocify.com/images/rel2.svg',
        title:'Shopify Development',
        desc:'Glocify provides flawless Stripe connection for Shopify applications.'
    },
    {
        icon:'https://glocify.com/images/rel3.svg',
        title:'React App Development',
        desc:'Glocify offers seamless Stripe integration for your React applications. '
    },
    {
        icon:'https://glocify.com/images/rel4.svg',
        title:'Node.js Apps',
        desc:'Enhance your Node.js apps with expert Stripe integration services. '
    },
    {
        icon:'https://glocify.com/images/rel5.svg',
        title:'Android App Development',
        desc:'We integrate Stripe for secure and efficient payments in your Android apps.'
    },
    {
        icon:'https://glocify.com/images/rel6.svg',
        title:'IOS App Developement',
        desc:'Glocify provides Stripe integration to ensure smooth transactions in your iOS apps.'
    },
    {
        icon:'https://glocify.com/images/rel7.svg',
        title:'WordPress Development',
        desc:'Enhance your WordPress sites with reliable Stripe payment integration.'
    },
    {
        icon:'https://glocify.com/images/rel8.svg',
        title:'Vue.js Development',
        desc:'We enable seamless payments in your Vue.js applications through Stripe integration.'
    },
]


return (

    <section className="section-1 pb-[40px]">
        <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
            <div className="text-center">
                <h1 className='lg:text-[55px]  text-[35px] mb-0 font-bold text-[#262626] relative inline-block'>{title} <span className=" rounded-[20px] w-[80px] m-auto h-[5px] bg-[#FB802C] block"></span></h1>
                 </div>
                 <div className="max-w-[1120px] mt-[55px] mx-auto rounded-[32px] bg-[#F2F2FF] lg:px-[45px] lg:py-[55px] p-6" >
                    <ul className="flex justify-between flex-wrap gap-y-6">
                        {glocifyservices.map((item, index)=>
                        <li key={index} className="lg:max-w-[49%] md:w-[49%] flex lg:px-[12px] lg:py-[22px]  p-[20px] bg-white rounded-[24px] w-full lg:flex-row flex-col" data-aos="fade-up"  data-aos-offset='150' data-aos-duration={(index + 1) * 250}>
                            <div><img className="lg:w-[80px]  w-[50px]" src={item.icon} alt="Glocify Service"/></div>
                            <div className="grow lg:pl-[20px] lg:pt-0  pt-4  lg:w-[calc(100%-80px)] w-full "><h4 className="tracking-tight text-[22px] text-[#262626] font-bold">{item.title}</h4>
                            <p className="text-[15px] text-[#262626] font-regular">{item.desc}</p>
                            </div>
                        </li>
                        )}
                    </ul>
                    <div  className="mt-[50px] text-center"> <SecondaryButton  title="Talk to an Expert"  toggleModal={toggleModal}/></div>            
                 </div>
        </div>
    </section>

)

}

export default RelatedService;
